<template>
  <el-dialog
    :title="setId?'编辑评估打分表':'新增评估打分表'"
    :visible.sync="scoreDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="800px"
    center>
    <el-form :model="scoreForm" :rules="rules" ref="scoreForm" label-width="150px">
      <el-form-item label="年度" prop="year">
        <el-date-picker
          v-model="scoreForm.year"
          style="width: 100%"
          type="year"
          placeholder="请选择年度">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="评估打分表名称" prop="name">
        <el-input v-model="scoreForm.name" placeholder="请输入评估打分表名称"></el-input>
      </el-form-item>
      <el-form-item label="注意事项" prop="desc">
        <VueUditorWrap v-model="scoreForm.desc" :config="myConfig"></VueUditorWrap>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('scoreForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('scoreForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig, zhDate} from "@/utils";
import { playSave} from "@/api/admin";

export default {
  name: "scoreDialog",
  props: {
    scoreDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {

    return {
      myConfig: bdEditConfig(),
      scoreForm: {
        name: '',
        phone: '',
        desc: '',
      },
      rules: {
        year: [{type: 'date', required: true, message: '请选择年度', trigger: 'change'}],
        name: [{required: true, message: '请输入评估打分表名称', trigger: 'blur'}],
        desc: [{required: true, message: '请输入注意事项', trigger: 'blur'}],
      }
    }
  },
  components:{
    VueUditorWrap
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await playSave(
        zhDate(new Date(this.scoreForm.year ),4),
        this.scoreForm.name,
        this.scoreForm.desc,
        this.setId ? this.setId : '',
      );
      if(_state.status === 200){
        this.$message.success(_state.info);
        this.$refs[formName].resetFields();
        this.$emit("cancelDialog", true);
      }

    }

  },
  watch: {
    setItem() {
      this.scoreForm = {
        year: new Date(this.setItem.year+ '-01-01'),
        name: this.setItem.name,
        desc: this.setItem.desc,
      };
    },
  }
}
</script>

<style scoped lang="scss">

</style>
